import stylesheet from './SuccessStoryList.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import {NXTSelectInput} from "../../parts/Input/Select";
import {getSlotElements} from "../../util/slot";

class NXTSuccessStoryList extends CustomComponent {

    cardContainer: HTMLElement;

    isFetchPending = false;
    isFetching = false;
    page = 1;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get api(): string {
        return this.getAttribute('api') ?? '';
    }

    get countryFilterValues(): string | undefined {
        return this.querySelector<NXTSelectInput>('[slot="filter-country"]')?.value;
    }

    get tagFilterValues(): string | undefined {
        return this.querySelector<NXTSelectInput>('[slot="filter-tag"]')?.value;
    }

    render() {
        const container = document.createElement('div');
        container.innerHTML = `
            <div class="base-grid">
                <div class="header">
                    <div class="filters">
                        <slot class="filter-country" name="filter-country"></slot>
                        <slot class="filter-tag" name="filter-tag"></slot>
                    </div>
                    <div class="pagination-text">
                        <slot name="pagination-text"></slot>
                    </div>
                </div>
                <div class="success-story-cards">
                    <slot name="top-story"></slot>
                    <slot></slot>
                </div>
                <div class="pagination">
                    <slot name="pagination"></slot>
                </div>
            </div>
        `;
        // Store Element references
        this.cardContainer = container.querySelector('.success-story-cards');
        // Attach events
        this.querySelector('[slot="filter-country"]')?.addEventListener('change', () => {
            this.page = 1;
            this.fetchData();
        });
        this.querySelector('[slot="filter-tag"]')?.addEventListener('change', () => {
            this.page = 1;
            this.fetchData();
        });
        this.querySelector('[slot="pagination"]').addEventListener('prev', () => {
            this.prevPage();
            this.fetchData();
        });
        this.querySelector('[slot="pagination"]').addEventListener('next', () => {
            this.nextPage();
            this.fetchData();
        });
        return container;
    }

    nextPage() {
        this.page++;
    }

    prevPage() {
        this.page--;
        if (this.page < 1) {
            this.page = 1;
        }
    }

    buildApiUrl(url: string, query: { [k: string]: string }): string {
        const apiUrl = new URL(url, location.href);
        const params = apiUrl.searchParams;
        for (const key of Object.keys(query)) {
            if (query[key]) {
                params.set(key, query[key]);
            }
        }
        return apiUrl.toString();
    }

    fetchData() {
        if (this.isFetching) {
            this.isFetchPending = true;
            return;
        }
        this.isFetching = true;
        fetch(this.buildApiUrl(this.api, {
            country: this.countryFilterValues,
            tag: this.tagFilterValues,
            page: this.page.toString(),
        })).then(async (response) => {
            if (response.ok) {
                const responseMarkup = document.createElement('div');
                responseMarkup.innerHTML = await response.text();
                this.updateSlotIfExists(responseMarkup, 'filter-country');
                this.updateSlotIfExists(responseMarkup, 'filter-tag');
                this.updateSlotIfExists(responseMarkup, 'pagination');
                this.updateSlotIfExists(responseMarkup, 'pagination-text');
                const newCards = getSlotElements(responseMarkup, '');
                for (const child of this.children) {
                    if (child.tagName.toLowerCase() == 'nxt-success-story-card' && child.slot !== 'top-story') {
                        (child as HTMLElement).style.display = 'none';
                    }
                }
                newCards.forEach(card => this.appendChild(card));
            }
        }).finally(() => {
            this.isFetching = false;
            if (this.isFetchPending) {
                this.isFetchPending = false;
                this.fetchData();
            }
        });
    }

}

customElements.define('nxt-success-story-list', NXTSuccessStoryList);
